import {
  MedicareBridgeCaseView,
  MedicareBridgeReviewDecision,
} from './medicare-bridge.types';
import { outstandingRequirementLabels } from './outstanding-requirements';
import { reviewAnswerLines } from './review-answers';
import { medicareBridgeRouteLabel } from './route-label';

const DECISION_LABEL: Record<MedicareBridgeReviewDecision, string> = {
  ELIGIBLE: 'Eligible',
  NOT_ELIGIBLE: 'Not eligible',
  NEEDS_INFORMATION: 'Needs information',
};

export function MedicareBridgeReviewSummary({
  bridgeCase,
}: {
  bridgeCase: MedicareBridgeCaseView;
}) {
  const review = bridgeCase.latestReview;
  if (!review) {
    return (
      <p className="text-sm text-muted-foreground">
        No Bridge review recorded yet.
      </p>
    );
  }

  const unresolved = outstandingRequirementLabels(
    review.checklist.items,
    review.unresolvedItems,
  );
  const answers = reviewAnswerLines(review.checklist.items, review.responses);
  const routeLabel = medicareBridgeRouteLabel(
    review.nextRoute,
    review.checklist.nextRoutes,
    bridgeCase.checklist.nextRoutes,
  );

  return (
    <dl
      className="flex flex-col gap-2 text-sm"
      data-testid="medicare-bridge-review-summary"
    >
      <div>
        <dt className="text-muted-foreground">Decision</dt>
        <dd className="font-medium text-foreground">
          {DECISION_LABEL[review.decision]}
        </dd>
      </div>
      <div>
        <dt className="text-muted-foreground">Unresolved</dt>
        <dd className="text-foreground">
          {unresolved.length === 0
            ? 'None'
            : unresolved.map((item) => item.label).join(', ')}
        </dd>
      </div>
      {review.nextRoute && (
        <div>
          <dt className="text-muted-foreground">Next route</dt>
          <dd className="text-foreground">{routeLabel}</dd>
        </div>
      )}
      {answers.length > 0 && (
        <div>
          <dt className="text-muted-foreground">Answers</dt>
          <dd className="text-foreground">
            <ul className="flex flex-col gap-1">
              {answers.map((answer) => (
                <li key={answer.key}>
                  {answer.label}: {answer.value}
                </li>
              ))}
            </ul>
          </dd>
        </div>
      )}
      {review.note && (
        <div>
          <dt className="text-muted-foreground">Note</dt>
          <dd className="text-foreground">{review.note}</dd>
        </div>
      )}
    </dl>
  );
}
